import { Skeleton } from '@heroui/react';

import {
  DeploymentIssueIndicator,
  DeploymentIssueInput,
  getDeploymentIssueSummary
} from '~/components/DeploymentIssueIndicator';
import {
  EnvironmentIndicator,
  EnvironmentType
} from '~/components/EnvironmentIndicator';
import {
  getMessageStatus,
  StatusKey
} from '~/scenes/Runtime/scenes/Deployments/utils/deploymentUtils';

export type DeployStatusCellProps = {
  status?: StatusKey;
  environment?: EnvironmentType;
  /** Optional: when given, a problem on the deployment is flagged next to the status. */
  deployment?: DeploymentIssueInput | null;
};

export type { StatusKey };

export const DeployStatusCell = ({
  status,
  environment,
  deployment
}: DeployStatusCellProps) => {
  if (!status || !environment) return null;

  const { icon: IconComponent, text } = getMessageStatus({
    deployStatus: status
  });

  const issueSummary = getDeploymentIssueSummary(deployment);

  return (
    <div className='flex w-[140px] items-center gap-3'>
      <IconComponent className='icon-small' />
      <div className='flex flex-col gap-1'>
        {/* Beside the status text, not under it: one indicator fits on the same line, and the
            column keeps its width. The row only exists when there is a problem, so a cell
            without one keeps the markup it always had. */}
        {issueSummary ? (
          <div className='flex items-center gap-1'>
            <p>{text}</p>
            <DeploymentIssueIndicator summary={issueSummary} />
          </div>
        ) : (
          <p>{text}</p>
        )}
        <EnvironmentIndicator environment={environment} />
      </div>
    </div>
  );
};

export const DeployStatusCellSkeleton = () => (
  <div className='flex w-[140px] items-center gap-3'>
    <Skeleton className='h-4 w-4 rounded' />
    <div className='flex flex-col gap-1'>
      <Skeleton className='h-4 w-16 rounded' />
      <Skeleton className='h-3 w-20 rounded' />
    </div>
  </div>
);
